import { styled, SxProp } from 'dripsy';
import React, { useCallback } from 'react';
import { View } from 'react-native';
import { ModalComponentProp } from 'react-native-modalfy';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { IconTouchable } from '../../components/common/IconTouchable';
import { ModalStackParamsType } from '../../modals/types';
import { BottomModalView } from './components/BottomModalView';
import { TutorialTimestamp } from '@models/Tutorials/TutorialTimestampModel';
import { TimestampList } from '../business/TimestampList';
import { Tutorial } from '@models/Tutorials/TutorialModel';

const List = styled(TimestampList)({
  flex: 0, // need to rub flex: 1 inside list
  flexGrow: 0,
  maxHeight: 500,
});

const CrossIconContainer = styled(View)({
  alignItems: 'flex-end',
  width: '100%',
  px: '$6',
  py: '$2',
});

function contentContainerStyle(insets: EdgeInsets): SxProp {
  return (theme) => ({
    pb: theme.space.$4 + insets.bottom,
    pl:
      insets.left && insets.right
        ? theme.space.$6 + insets.left
        : '$6',
    pr:
      insets.left && insets.right
        ? theme.space.$6 + insets.right
        : '$6',
  });
}

export interface ITimestampsModalParams {
  tutorial: Tutorial;
  onSelect(item: TutorialTimestamp): void;
}

type ModalPropsType = ModalComponentProp<
  ModalStackParamsType,
  void,
  'TimestampsModal'
>;

export function TimestampsModal({ modal }: ModalPropsType) {
  const insets = useSafeAreaInsets();

  function closeModalByCrossIcon() {
    modal.closeModal();
  }

  const selectTimestamp = useCallback((item: TutorialTimestamp) => {
    modal.params?.onSelect(item);
    modal.closeModal();
  }, []);

  return (
    <BottomModalView>
      <CrossIconContainer>
        <IconTouchable
          onPress={closeModalByCrossIcon}
          name="close-light"
          size={24}
        />
      </CrossIconContainer>

      <List
        contentContainerSx={contentContainerStyle(insets)}
        onPress={selectTimestamp}
        tutorial={modal.params?.tutorial as Tutorial}
      />
    </BottomModalView>
  );
}
